export default __webpack_public_path__ + "static/media/form-img.5a36b19d.png";